<template>
    <div class="recommend">
        <div class="title">推荐赛事</div>
        <el-table class="recommendBox" :data="recommendActivity" border style="width: 100%">
            <el-table-column prop="title" label="名称" align="center"></el-table-column>
            <el-table-column label="级别" align="center">
                <template slot-scope="scope">
                    <span>{{levelData[scope.row.levelId]}}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        recommendActivity: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            levelData: {
                5: 'SSS级别',
                6: 'SS级别',
                10: 'S级别',
                11: 'A级别',
                12: 'B级别',
                13: 'C级别',
                14: 'D级别',
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.recommend{
    width: 347px;
    border-radius: 12px;
    overflow: hidden;
}
.recommendBox{
    background-color: #292941;
    border-radius: 12px;
    height: 100%;
}
.title{
    margin-top: 24px;
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
}
::v-deep thead{
    color: #A1A1CC
}
::v-deep .el-table tr{
    background-color: transparent !important;
    border: none !important;
    
}
::v-deep .el-table th{
    background-color: transparent !important;
    border: none !important;
}
::v-deep .el-table td{
    border: none !important;
    color: #fff;
    border-bottom: 1px solid #2F2F48 !important
}
::v-deep .el-table tbody tr:hover>td {
    background-color: #222236 !important
}
.el-table::before{
    height: 0;
}
.el-table--border::after{
    width: 0;
}
.el-table--border, .el-table--group{
    border: none !important
}
</style>
